import React from "react";
import { Box, Button, useDisclosure } from "@chakra-ui/react";
import { ViewScore } from "./ViewScore";
import { t } from "i18next";
import { Score } from "@keita/lanepatrol-sdk";
import { CustomDialog } from "../../shared/views/CustomDialog";
import { getColor, lightenColor } from "../../survey/utils/score-utils";

interface Props {
  score: Score;
  showLabel?: boolean;
}

export const ScoringBubble: React.FC<Props> = ({
  score,
  showLabel = false,
}) => {
  const { open, onOpen, onClose } = useDisclosure();
  const color = getColor(score.global.riskFactor);
  const lightColor = lightenColor(color, 0.72);

  return (
    <>
      <Button
        onClick={(event) => {
          event.stopPropagation();
          onOpen();
        }}
        size="xs"
        p="2px"
        bg={color}
        borderWidth="1px"
        borderColor="blackAlpha.200"
        borderRadius="md"
        _hover={{ bg: color }}
        _active={{ bg: color }}
      >
        <Box
          bg={lightColor}
          color="black"
          borderRadius="sm"
          px={2}
          py={1}
          fontSize="sm"
          fontWeight="bold"
          lineHeight="short"
        >
          {showLabel
            ? t("coding:currentRating", {
                rating: score.global.value.toFixed(2),
              })
            : score.global.value.toFixed(3)}
        </Box>
      </Button>

      {open && (
        <CustomDialog size={"xl"} onClose={onClose} header={null}>
          <ViewScore score={score} />
        </CustomDialog>
      )}
    </>
  );
};
